import React from 'react'

const Appointment = () => {
  return (
    <div>
      appointment
    </div>
  )
}

export default Appointment
